import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { AwarenessSection } from '../components/AwarenessSection';
import { AboutSection } from '../components/AboutSection';
import { Method3S } from '../components/Method3S';
import { ServicesSection } from '../components/ServicesSection';
import { FreeSessionCTA } from '../components/FreeSessionCTA';
import { ResourcesSection } from '../components/ResourcesSection';
import { Testimonials } from '../components/Testimonials';
import { FAQ } from '../components/FAQ';
import { Footer } from '../components/Footer';
export function Home() {
  return <div className="min-h-screen bg-brand-bg font-sans text-brand-text selection:bg-brand-primary/20" data-id="element-286">
      <Navbar data-id="element-287" />
      <main data-id="element-288">
        <Hero data-id="element-289" />
        <AwarenessSection data-id="element-290" />
        <AboutSection data-id="element-291" />
        <Method3S data-id="element-292" />
        <ServicesSection data-id="element-293" />
        <FreeSessionCTA data-id="element-294" />
        <ResourcesSection data-id="element-295" />
        <Testimonials data-id="element-296" />
        <FAQ data-id="element-297" />
      </main>
      <Footer data-id="element-298" />
    </div>;
}